import React from 'react';

const StatCard = ({ title, value, icon, color, subtitle, trend, onClick }) => {
  return (
    <div
      className="stat-card"
      onClick={onClick}
      style={{ '--card-color': color, cursor: onClick ? 'pointer' : 'default' }}
    >
      <div className="stat-card__header">
        <p className="stat-card__label">{title}</p>
        <div className="stat-card__icon" style={{ backgroundColor: `${color}18`, color }}>
          <i className={`pi ${icon}`}></i>
        </div>
      </div>

      <p className="stat-card__value">
        {typeof value === 'number' ? value.toLocaleString() : value}
      </p>

      <div className="stat-card__footer">
        {subtitle && <span className="stat-card__subtitle">{subtitle}</span>}
        {trend !== undefined && (
          <span className={`stat-card__trend ${trend >= 0 ? 'up' : 'down'}`}>
            <i className={`pi ${trend >= 0 ? 'pi-arrow-up' : 'pi-arrow-down'}`}></i>
            {Math.abs(trend)}%
          </span>
        )}
      </div>
    </div>
  );
};

export default StatCard;
